module.exports = __webpack_public_path__ + "img/equipment-10@2x.8b99f2ad.jpg";